module.exports = __webpack_public_path__ + "img/34.9.TU.b750b000.png";